import React from 'react';
import {
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  Grid,
  TextField,
  InputAdornment,
} from '@mui/material';
import { MuiColorInput } from 'mui-color-input';

const IconToggleField = ({ settings, onChange }) => {
  const handleChange = (field, value) => {
    onChange(field, value);
  };

  return (
    <Box sx={{ mt: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 2 }}>
      <Typography variant="h6" gutterBottom>
        Icon Toggle Settings
      </Typography>
      
      <FormControlLabel
        control={
          <Checkbox
            checked={settings.showIconToggle || false}
            onChange={(e) => handleChange('showIconToggle', e.target.checked)}
          />
        }
        label="Show Icon Toggle Button"
      />

      {settings.showIconToggle && (
        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" gutterBottom>
              Icon Size (px)
            </Typography>
            <TextField
              value={settings.iconSize || '24'}
              onChange={(e) => handleChange('iconSize', e.target.value)}
              fullWidth
              size="small"
              type="number"
              InputProps={{
                endAdornment: <InputAdornment position="end">px</InputAdornment>,
              }}
            />
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" gutterBottom>
              Icon Color (On State)
            </Typography>
            <MuiColorInput
              format="hex"
              value={settings.iconColor || '#4CAF50'}
              onChange={(value) => handleChange('iconColor', value)}
              fullWidth
              size="small"
            />
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" gutterBottom>
              Icon Color (Off State)
            </Typography>
            <MuiColorInput
              format="hex"
              value={settings.iconOffColor || '#757575'}
              onChange={(value) => handleChange('iconOffColor', value)}
              fullWidth
              size="small"
            />
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default IconToggleField;